import RemitoCompraAPI from '@/api/compra/remito';

export default {
  namespaced: true,
  actions: {
    fetch_remito_compra(_, params) {
      return RemitoCompraAPI.index(params);
    },
  },
};
